export default __webpack_public_path__ + "static/media/organizations_page_icon.06608354.svg";